import { supabase } from '@/lib/supabase';
import { normalizePhone } from '@/lib/phone';
import { errorMessage, isUnauthorizedPhone, UNKNOWN_PHONE_ERROR } from '@/lib/errors';

export type AuthResult = { ok: true } | { ok: false; message: string };

/**
 * בקשת קוד חד פעמי.
 *
 * shouldCreateUser חייב להיות true: בכניסה הראשונה של עובד עדיין אין לו
 * משתמש Auth, ו false היה חוסם אותו לנצח עם "Signups not allowed for otp".
 *
 * "אין הרשמה עצמית" (PRD 2.6) נאכף בשרת, לא כאן, וזו בדיוק הנעילה הכפולה:
 *   1. hook_before_user_created דוחה יצירת משתמש לכל מספר שאינו עובד פעיל.
 *   2. send-sms בודקת שוב ולא שולחת הודעה למספר לא מורשה.
 * שני ה hooks חייבים להיות רשומים בפרויקט, אחרת אין שום חסימה.
 */
export async function requestOtp(rawPhone: string): Promise<AuthResult> {
  const phone = normalizePhone(rawPhone);
  if (!phone) return { ok: false, message: 'מספר הטלפון לא תקין. הזן/י מספר נייד.' };

  const { error } = await supabase.auth.signInWithOtp({
    phone,
    options: { shouldCreateUser: true },
  });

  if (error) {
    return {
      ok: false,
      message: isUnauthorizedPhone(error) ? UNKNOWN_PHONE_ERROR : errorMessage(error),
    };
  }
  return { ok: true };
}

export async function verifyOtp(rawPhone: string, code: string): Promise<AuthResult> {
  const phone = normalizePhone(rawPhone);
  if (!phone) return { ok: false, message: 'מספר הטלפון לא תקין.' };

  const { error } = await supabase.auth.verifyOtp({ phone, token: code, type: 'sms' });
  if (error) return { ok: false, message: errorMessage(error) };
  return { ok: true };
}

export async function signOut() {
  await supabase.auth.signOut();
}
